import { useMutation } from "@tanstack/react-query";
import {
  EmailTemplateLanguageType,
  EmailTemplateSubjectEnum,
  ICreateOrUpdateEmailTemplate,
} from "../../models/EmailTemplate";
import { EmailTemplateService } from "../../services/email-template.service";

export const useEmailTemplateMutations = () => {
  const { mutate: createOrUpdateEmailTemplate } = useMutation<
    any,
    Error,
    ICreateOrUpdateEmailTemplate
  >({
    mutationFn: async (model) => EmailTemplateService.createOrUpdateEmailTemplate(model),
  });

  const { mutate: deleteEmailTemplate } = useMutation<any, Error, string>({
    mutationFn: async (id) => EmailTemplateService.deleteEmailTemplate(id),
  });

  const { mutate: testSendEmailTemplate } = useMutation<
    any,
    Error,
    { to: string; language: EmailTemplateLanguageType; subject: EmailTemplateSubjectEnum }
  >({
    mutationFn: async ({ to, language, subject }) =>
      EmailTemplateService.testSendEmailTemplate(to, language, subject),
  });

  return {
    createOrUpdateEmailTemplate,
    deleteEmailTemplate,
    testSendEmailTemplate,
  };
};
